module.exports = __webpack_public_path__ + "img/Left_down.e10e4c3c.svg";